import { useEffect } from "react";

const SELECTOR = "main p, main li, main dd, main blockquote, main figcaption, footer p";
const NBSP = "\u00A0";
const MAX_JOINED = 24;

const lastTextNode = (el) => {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  let last = null;
  for (let n = walker.nextNode(); n; n = walker.nextNode()) if (n.nodeValue.trim()) last = n;
  return last;
};

const fix = (el) => {
  if ((el.textContent || "").trim().split(/\s+/).length < 4) return;
  const node = lastTextNode(el);
  if (!node) return;
  const text = node.nodeValue.replace(/\s+$/, "");
  const i = Math.max(text.lastIndexOf(" "), text.lastIndexOf(NBSP));
  if (i <= 0 || text[i] === NBSP || text.length - i > MAX_JOINED) return;
  const before = text.lastIndexOf(" ", i - 1);
  if (text.slice(before + 1).length > MAX_JOINED) return;
  node.nodeValue = `${text.slice(0, i)}${NBSP}${text.slice(i + 1)}${node.nodeValue.slice(text.length)}`;
};

const run = () => document.querySelectorAll(SELECTOR).forEach(fix);

export const NoWidows = () => {
  useEffect(() => {
    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(run);
    };
    run();
    const obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => {
      obs.disconnect();
      cancelAnimationFrame(frame);
    };
  }, []);
  return null;
};
